const setTimerData = async (timerData) => {
  return timerData;
};

const timerDataService = {
  setTimerData: setTimerData,
};

export default timerDataService;
